"use strict";
var _a;
exports.__esModule = true;
exports.reducers = void 0;
var device_metadata_1 = require("./modules/device-metadata");
var payment_details_1 = require("./modules/payment-details");
var user_account_1 = require("./modules/user-account");
var onboarding_status_1 = require("./modules/onboarding-status");
var prefills_1 = require("./modules/prefills");
var feature_status_1 = require("./modules/feature-status");
var wallet_balance_1 = require("./modules/wallet-balance");
var eligibility_check_1 = require("./modules/eligibility-check");
var agreements_1 = require("./modules/agreements");
var config_1 = require("./modules/config");
var property_linking_1 = require("./modules/property-linking");
var embed_1 = require("./modules/embed");
/*
  Eventually when we migrate all reducers to this package we can use combineReducer and define the RootState
*/
exports.reducers = (_a = {
        userAccount: user_account_1.userAccountReducer,
        paymentDetails: payment_details_1.paymentDetailsReducer,
        onboardingStatus: onboarding_status_1.onboardingStatusReducer,
        prefills: prefills_1.prefillsReducer,
        featureStatus: feature_status_1.featureStatusReducer,
        walletBalance: wallet_balance_1.walletBalanceReducer,
        eligibilityCheck: eligibility_check_1.eligibilityCheckReducer,
        propertyLinking: property_linking_1.propertyLinkingReducer,
        agreements: agreements_1.agreementsReducer,
        deviceMetadata: device_metadata_1.deviceMetadataReducer
    },
    _a[config_1.CONFIG_REDUCER_NAME] = config_1.configReducer,
    _a.embed = embed_1.embedReducer,
    _a);
